export default function MessageBox({ children }) {

    return (
        <div style={{
            padding: 10,
            backgroundColor: '#FFFBE8',
            color: 'rgba(0,0,0,0.8)',
            borderRadius: 7,
            width: '100%'
        }}>
            {children}
        </div>
    )
}